"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _ThemeUtils = require("../api/theme/ThemeUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const onEnterRoute = (props, menuItem) => {
  if (typeof menuItem !== 'undefined') {
    _SecurityContextHolder.SecurityContextHolder.getCurrentContext().verifySubSite(props, menuItem);
    // eslint-disable-next-line no-console
    //        console.log(`[${new Date()}] Entering Route ${JSON.stringify(menuItem)}`);
  }
};

// eslint-disable-next-line no-unused-vars
const onLeaveRoute = (menuItem, startDate) => {
  if (typeof menuItem !== 'undefined') {
    // eslint-disable-next-line no-console
    //        console.log(`[${new Date()}] Leaving Route ${JSON.stringify(menuItem)}`);
  }
};
class TrackedComponent extends _react.Component {
  componentDidMount() {
    const {
      menuItem
    } = this.props;
    (0, _ThemeUtils.applyTheme)(menuItem.theme);
    onEnterRoute(this.props, menuItem);
  }
  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error(JSON.stringify(error));
  }
  render() {
    const {
      children,
      menuItem
    } = this.props;
    const startDate = new Date();
    const renderResults = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children);
    onLeaveRoute(menuItem, startDate);
    return renderResults;
  }
}
exports.default = TrackedComponent;
TrackedComponent.propTypes = {
  menuItem: _propTypes.default.shape({
    theme: _propTypes.default.string
  }),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};
//# sourceMappingURL=TrackedComponent.js.map